const timeFrameBarOptions = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '10px',
};

export { timeFrameBarOptions };
